import React, { Component } from "react"
import "./ChooseModelModal.css"
import { getTranslation } from "../../assets/creator/translations"
import SalesModel from "../SalesModel/SalesModel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo } from "@fortawesome/free-solid-svg-icons";
import { linksGenerator } from "../../utils/welcomeModalsUtils";

class ChooseModelModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedModel: "wholesale"
		}
	}

	handleCloseButton = () => {
		this.props.handleClose();
		this.props.handleRestore();
	}

	handleReturnButton = () => {
		this.setState({ selectedModel: "wholesale" });
		this.props.handleOpenWelcomeMenu();
	}

	handleConfirmButton = async () => {
		if (this.state.selectedModel) {
			if (this.state.selectedModel === "retail") {
				const link = await linksGenerator();
				let b2cCreatorLink = link.b2c + "?model=b2c&edited=false";
				b2cCreatorLink += `&lang=${this.props.lang}`;
				window.location.href = b2cCreatorLink;
			} else {
				this.props.handleOpenTemplatesMenu();
			}
		}
	}

	render() {
		if (!this.props.show) {
			return null;
		}

		return (
			<div className='choose-model-modal'>
					<section className='choose-model-modal__main '>
						<div className="choose-model-modal__title-wrapper">
							<div className='choose-model-modal__title'>
								{getTranslation("Msg_ChooseModelTitle")}
							</div>
							{this.props.isRefresh && (
								<button className='choose-model-modal__close' onClick={this.handleCloseButton}>
									<CloseIcon />
								</button>
							)}
						</div>
						<div className='choose-model-modal__text'>
							<p>{getTranslation("Msg_ChooseModelText")}</p>
						</div>
						<div className="choose-model-modal__models">
							{this.state.selectedModel === "wholesale" && (
								<div className="choose-model-modal__models-info">
									<FontAwesomeIcon icon={faInfo} className="choose-model-modal__models-info-icon" />
									<div className="choose-model-modal__models-info-text">
										{getTranslation("Msg_WholesaleInfo")}
									</div>
								</div>
							)}
							<div className="choose-model-modal__models-content">
								<SalesModel 
									modelTitle={getTranslation("Msg_RetailTitle")}
									modelText={getTranslation("Msg_RetailText")}
									isSelected={this.state.selectedModel === "retail"}
									clickFunction={() => this.setState({ selectedModel: "retail" })}
								/>
								<SalesModel
									modelTitle={getTranslation("Msg_WholesaleTitle")}
									modelText={getTranslation("Msg_WholesaleText")}
									isSelected={this.state.selectedModel === "wholesale"}
									clickFunction={() => this.setState({ selectedModel: "wholesale" })}
								/>
							</div>
						</div>
						<div className='choose-model-modal__btn-group'>
							{!this.props.isRefresh && !this.props.isMemoryEmpty() && (
								<p className='welcome-modal__link continueEditProjectBtn' onClick={this.handleReturnButton}>
									{getTranslation("Btn_Return")}
								</p>
							)}
							<button
								className='choose-model-modal__btn choose-model-modal__btn--active chooseBtn'
								onClick={this.handleConfirmButton}>
								{getTranslation("Btn_Confirm")}
							</button>
						</div>
						<span className="border-line"></span>
					</section>
				</div>
		);
	}
}

export default ChooseModelModal

const CloseIcon = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" >
        <path fillRule="evenodd" d="M18.69 5.321a1.057 1.057 0 0 0-1.498 0L12 10.503 6.808 5.31A1.057 1.057 0 1 0 5.31 6.808L10.503 12 5.31 17.192a1.057 1.057 0 1 0 1.497 1.497L12 13.497l5.192 5.192a1.057 1.057 0 1 0 1.497-1.497L13.497 12l5.192-5.192a1.064 1.064 0 0 0 0-1.487z" />
    </svg>
)